import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './index.css';
import App from './App';
import { theme } from './theme';
import ErrorPage from './routes/Error';
import Opps from './routes/Opps';
import Settings from './routes/Settings';
import Notifications from './routes/Notifications';
import NotificationPreview from './routes/NotificationPreview';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement!);
const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/opps',
    element: <Opps />,
  },
  {
    path: '/settings',
    element: <Settings />,
  },
  {
    path: '/notifications',
    element: <Notifications />,
  },
  {
    path: '/notification-preview',
    element: <NotificationPreview />,
  }
]);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  </React.StrictMode>
);
